<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },

})

const height = computed(() => props.height)
const width = computed(() => props.height)
</script>

<template>
  <svg :width="height" :height="height" viewBox="0 0 65 64" xmlns="http://www.w3.org/2000/svg" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,0.000200682,-0.487)">
        <path d="M31.848,0.487C36.841,0.487 41.592,1.631 45.855,3.687C46.525,3.989 47.195,4.35 47.863,4.711L44.94,7.3L40.558,2.785L33.008,9.405L28.56,4.64L14.675,16.982L23.565,26.674L20.095,29.684L28.865,39.376L25.395,42.384L37.94,56.17L45.365,49.427L51.823,56.653C50.543,57.616 49.143,58.581 47.623,59.423C42.823,62.11 37.412,63.518 31.911,63.513C14.31,63.513 0,49.37 0,31.973C-0.062,14.694 14.25,0.487 31.848,0.487ZM26,30.045L33.612,23.302L40.434,30.827L32.82,37.569L26,30.045ZM31.42,43.048L38.97,36.246L45.852,43.77L38.239,50.513L31.42,43.048ZM20.584,17.223L28.184,10.48L35.004,18.005L27.391,24.747L20.584,17.223ZM34.527,13.6L40.2,8.554L45.316,14.154L39.652,19.27L34.527,13.6ZM44.627,36.777L50.3,31.73L55.416,37.387L49.752,42.447L44.627,36.777ZM49.62,48.157L55.284,43.099L60.396,48.699L54.734,53.815L49.62,48.157ZM51.935,22.15L55.71,18.778L59.12,22.512L55.346,25.882L51.935,22.15ZM47.063,11.013L50.838,7.583L54.25,11.375L50.472,14.745L47.063,11.013ZM56.745,33.288L60.52,29.918L64,33.658L60.165,37.028L56.745,33.288ZM39.745,24.92L45.409,19.863L50.523,25.461L44.861,30.519L39.745,24.92Z" style="fill:rgb(16,109,179);fill-rule:nonzero;"/>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
